var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7168 0.6399C14.0013 0.925056 14.1194 1.94902 13.7288 2.33959L5.72969 10.3383C5.3391 10.7289 4.7048 10.7289 4.31422 10.3383L0.314665 6.33897C-0.0759168 5.9484 -0.0759168 5.01831 0.314665 4.62775C0.705246 4.23718 1.63237 4.23718 2.02295 4.62775L5.02295 7.62775L12.0229 0.474686C12.4135 0.0841221 13.237 0.221463 13.5045 0.425225L13.7168 0.6399Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSolid);
export default __webpack_public_path__ + "static/media/check-solid.c7a918e7a23444de5746347cf11e69c1.svg";
export { ForwardRef as ReactComponent };